<div class="mat-dialog-device-details">
  <form [formGroup]="userForm">
    <div mat-dialog-title class="dialog-title">
      <h2>{{headerName}}</h2>
      <button mat-icon-button aria-label="close dialog" [mat-dialog-close]="true">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <mat-dialog-content class="mat-typography">
      <div class="device-details-form">
        <mat-grid-list cols="2" rowHeight="80px">
          <!-- <mat-grid-tile *ngIf="isEdiable">
            <div class="w-100">
              <mat-form-field appearance="outline" class="form-feild">
                <mat-label class="asterix--before">ID </mat-label>
                <input readonly matInput type="text" class="form-controll" name="id" formControlName="id" />
               <mat-error *ngIf="userForm.invalid">
                {{errorMessageFormField.ec2Id}}
                </mat-error>
              </mat-form-field>
            </div>
          </mat-grid-tile> -->
          <mat-grid-tile>
            <div class="w-100">
              <mat-form-field appearance="outline" class="form-feild">
                <mat-label>Node Name </mat-label>
                <input matInput type="text" class="form-controll" name="nodeName" formControlName="nodeName"
                  [readonly]="isEditable" />
                <mat-error *ngIf="userForm.invalid">
                  {{errorMessageFormField.ec2NodeName}}
                </mat-error>
              </mat-form-field>
            </div>
          </mat-grid-tile>
          <mat-grid-tile>
            <div class="w-100">
              <mat-form-field appearance="outline" class="form-feild">
                <mat-label>Instance ID </mat-label>
                <input matInput type="text" class="form-controll" name="instanceId" formControlName="instanceId" />
                <mat-error *ngIf="userForm.invalid">
                  {{errorMessageFormField.ec2InstanceId}}
                </mat-error>
              </mat-form-field>
            </div>
          </mat-grid-tile>
          <mat-grid-tile>
            <div class="w-100">
              <mat-form-field appearance="outline" class="form-feild">
                <mat-label>Private IP </mat-label>
                <input matInput type="text" class="form-controll" name="privateIp" formControlName="privateIp" />
                <mat-error *ngIf="userForm.invalid">
                  {{errorMessageFormField.ec2PrivateId}}
                </mat-error>
              </mat-form-field>
            </div>
          </mat-grid-tile>
          <mat-grid-tile>
            <div class="w-100">
              <mat-form-field appearance="outline" class="form-feild">
                <mat-label class="">Public IP </mat-label>
                <input matInput type="text" class="form-controll" name="publicIp" formControlName="publicIp" />
                <mat-error *ngIf="userForm.invalid">
                  {{errorMessageFormField.ec2PublicId}}
                </mat-error>
              </mat-form-field>
            </div>
          </mat-grid-tile>
        </mat-grid-list>
        <div class="nots-text"> </div>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-raised-button class="edit-btn" type="submit" *ngIf="isEditable" (click)="updateForm()">
        Update
      </button>
      <button mat-raised-button class="edit-btn" type="submit" *ngIf="!isEditable" (click)="addFarm()">
        Add
      </button>
    </mat-dialog-actions>
  </form>
</div>